// adapted from: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/operators/routingRulesSetters.js
import setIn from 'transmute/setIn';
import { FALLBACK, TEAM_IDS, USER_IDS } from '../constants/keyPaths';
export const setFallback = setIn(FALLBACK);
export const setTeamIds = setIn(TEAM_IDS);
export const setUserIds = setIn(USER_IDS);